import { useEditCustomItem } from "../../hooks"
import { editCustomRepairTimeItem } from "../editCustomRepairTimeItem"
import { CustomRepairTimeItemResponse } from "../models"
import { QUERY_KEY_REPAIRTIMES } from "./keys"

export function useEditCustomRepairTimeItem() {
    return useEditCustomItem(QUERY_KEY_REPAIRTIMES, editCustomRepairTimeItem, (response, _, prevData: CustomRepairTimeItemResponse[]) =>
        prevData.map((x) => (response && x.id === response?.editedCustomRepairTime.id ? response.editedCustomRepairTime : x))
    )
}
